/**
 * darstellung – Theme und Schriftgröße je Benutzer (Welle 99).
 *
 * Bis hierher war Darkmode fest in index.js verdrahtet (Entscheid 2026-07-28).
 * Ein zweiter Benutzer kam mit dem dunklen Hintergrund und der kleinen Schrift
 * nicht zurecht, deshalb hängt beides jetzt am Konto.
 *
 * Gespeichert wird serverseitig in `user_einstellungen` (theme,
 * schriftgroesse). Der zuletzt bekannte Wert liegt zusätzlich im
 * localStorage — nur damit beim Laden nichts aufblitzt, bevor die Antwort
 * vom Server da ist. Die Wahrheit ist immer der Server.
 */
import { API_BASE } from "../api/config";

const SPEICHER = "darstellung";

export const THEMES = ["dunkel", "hell"];
export const SCHRIFTGROESSEN = ["normal", "gross", "sehr_gross"];

// Die Grundgröße, an der alle rem-Werte hängen. Die vielen harten px-Werte
// in den Seiten-CSS ziehen hier NICHT mit — die werden Seite für Seite
// umgestellt (siehe Welle 99, Teil A3).
const WURZEL_PX = { normal: 16, gross: 17.6, sehr_gross: 19.2 };

export const VORGABE = { theme: "dunkel", schriftgroesse: "normal" };

/** Zuletzt bekannte Einstellung — ohne Server, für den ersten Render. */
export function gemerkteDarstellung() {
  try {
    const roh = localStorage.getItem(SPEICHER);
    if (!roh) return VORGABE;
    const d = JSON.parse(roh);
    return {
      theme: THEMES.includes(d.theme) ? d.theme : VORGABE.theme,
      schriftgroesse: SCHRIFTGROESSEN.includes(d.schriftgroesse)
        ? d.schriftgroesse
        : VORGABE.schriftgroesse,
    };
  } catch {
    return VORGABE;
  }
}

/** Setzt Theme und Schriftgröße am Dokument und merkt sie sich. */
export function wendeDarstellungAn({ theme, schriftgroesse } = {}) {
  const t = THEMES.includes(theme) ? theme : gemerkteDarstellung().theme;
  const s = SCHRIFTGROESSEN.includes(schriftgroesse)
    ? schriftgroesse
    : gemerkteDarstellung().schriftgroesse;

  const wurzel = document.documentElement;
  wurzel.setAttribute("data-theme", t === "hell" ? "light" : "dark");
  wurzel.style.fontSize = `${WURZEL_PX[s]}px`;
  // body.dark-mode bleibt der Schalter, an dem die bestehenden CSS-Regeln
  // hängen — es gibt rund 21 CSS-Dateien, die darauf hören.
  document.body.classList.toggle("dark-mode", t !== "hell");
  document.body.classList.toggle("hell-mode", t === "hell");

  try {
    localStorage.setItem(SPEICHER, JSON.stringify({ theme: t, schriftgroesse: s }));
  } catch {
    /* privates Fenster o. ä. — dann eben ohne Gedächtnis */
  }
  return { theme: t, schriftgroesse: s };
}

/** Holt die Einstellung des angemeldeten Benutzers und wendet sie an. */
export async function ladeDarstellungVomServer() {
  const token = localStorage.getItem("maToken");
  if (!token) return null;
  try {
    const r = await fetch(`${API_BASE}/benutzer/einstellungen`, {
      headers: { "X-MA-Token": token },
    });
    if (!r.ok) return null;
    const d = await r.json();
    return wendeDarstellungAn(d);
  } catch {
    return null;   // offline: es bleibt beim gemerkten Wert
  }
}
